export default class DtoInstallationActivity {
    constructor(obj) {
        this.code = obj.code
        this.code2 = obj.code2
        this.label = obj.label
    }
}